import { Plane, ShieldCheck, Waves, UtensilsCrossed } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useLang } from "@/context/LangContext";

export const ADDONS = { roof_rack: ["day", 100000], board_storage: ["once", 75000], durian_stop: ["once", 0], nasi_kapau: ["once", 0] };
export const ADDON_KEYS = { roof_rack: "addon_roof_rack", board_storage: "addon_board_storage", durian_stop: "addon_durian", nasi_kapau: "addon_kapau" };
export const addonCost = (addons, days) => addons.reduce((s, a) => s + ADDONS[a][1] * (ADDONS[a][0] === "day" ? days : 1), 0);

const Check = ({ id, label, price, value, onToggle }) => (
  <label data-testid={`booking-addon-label-${id}`} className="flex min-h-11 items-center gap-3 py-2 text-sm text-slate-800">
    <input type="checkbox" data-testid={`booking-addon-${id}`} checked={value.includes(id)} onChange={() => onToggle(id)} className="h-4 w-4 accent-[#064E3B]" />
    <span className="min-w-0 flex-1 [overflow-wrap:anywhere]">{label}</span><b className="max-w-[40%] text-right text-xs text-slate-600 [overflow-wrap:anywhere]">{price}</b>
  </label>
);

export function CarAddons({ value, onChange }) {
  const { t, money } = useLang();
  const toggle = (id) => onChange(value.includes(id) ? value.filter((x) => x !== id) : [...value, id]);
  const p = { value, onToggle: toggle };
  return (
    <div className="space-y-2">
      <div data-testid="booking-surf-addons" className="rounded-2xl border border-sky-200 bg-sky-50 p-3">
        <p className="mb-1 flex items-center gap-1.5 text-xs font-extrabold uppercase tracking-wide text-sky-900"><Waves className="h-4 w-4" />{t("addon_surf_title")}</p>
        <Check id="roof_rack" label={t("addon_roof_rack")} price={`${money(100000)}${t("per_day")}`} {...p} />
        <Check id="board_storage" label={t("addon_board_storage")} price={`${money(75000)}${t("per_night")}`} {...p} />
      </div>
      <div data-testid="booking-food-addons" className="rounded-2xl border border-orange-200 bg-orange-50 p-3">
        <p className="flex items-center gap-1.5 text-xs font-extrabold uppercase tracking-wide text-orange-900"><UtensilsCrossed className="h-4 w-4" />{t("addon_food_title")}</p>
        <p className="mb-1 text-xs text-orange-800">{t("addon_food_sub")}</p>
        <Check id="durian_stop" label={t("addon_durian")} price={t("free")} {...p} />
        <Check id="nasi_kapau" label={t("addon_kapau")} price={t("free")} {...p} />
      </div>
    </div>
  );
}

export function TransportField({ value, onChange }) {
  const { t } = useLang();
  return (
    <div>
      <Label htmlFor="booking-transport" className="flex items-center gap-1.5"><Plane className="h-4 w-4 text-[#E11D48]" />{t("transport_label")} *</Label>
      <Input id="booking-transport" data-testid="booking-transport-input" required maxLength={120} placeholder={t("transport_ph")} value={value} onChange={(e) => onChange(e.target.value)} />
      {value.trim() && <p data-testid="booking-transport-note" className="mt-1.5 flex items-start gap-1.5 rounded-xl bg-emerald-50 px-3 py-2 text-xs font-medium text-emerald-800"><ShieldCheck className="mt-0.5 h-3.5 w-3.5 shrink-0" />{t("transport_popup")}</p>}
    </div>
  );
}
